import React, { useState } from "react";
import PortalModal from "../../components/modals/Common/PortalModal.jsx";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes.jsx";


const PortalPage = () => {
  const [isModalOpen, setModalOpen] = useState(true);

  const handleClose = () => setModalOpen(false);

  const navigate = useNavigate();
  const handleSelect = (portal) => {
    console.log("Selected portal:", portal);
    // Navigate based on portal choice
    if (portal === "POS") navigate(all_routes.pos); // or use navigate("/pos")
    if (portal === "Booking") navigate(all_routes.backOfHouse);
  };

  const handleSignOut = () => {
    console.log("Signed out");
    navigate(all_routes.signin); // return to login
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100 bg-light"
      style={{ minHeight: "100vh" }}
    >
      <h2 className="text-muted">Welcome, Carl 👋</h2>

      {/* ✅ Show modal immediately */}
      <PortalModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onSelect={handleSelect}
        onSignOut={handleSignOut}
      />
    </div>
  );
};

export default PortalPage;
